import ResignationNotification from "./resignationNotification";
export default ResignationNotification;